export let LocalEventsManager = new kendo.Observable();
export default LocalEventsManager;